import { CHAT_COMPLETIONS_API_URL, OPEN_AI_MODELS } from '@/constants/gpt'
import {
  IGptResponse,
  IGptResponseQuestionToSpeakableText,
} from '@/src/types/gpt'
import { THistoryMessage } from '@/types/firebase'
import { safeJsonParse } from '@/utils/safeJsonParse'
import axios from 'axios'

const API_KEY = process.env.OPENAI_API_KEY || ''

const models = OPEN_AI_MODELS

async function questionToSpeakableTextGptRequest(
  messages: THistoryMessage[],
): Promise<IGptResponseQuestionToSpeakableText | undefined> {
  for (let model of models) {
    try {
      const { data } = await axios.post<
        IGptResponse<IGptResponseQuestionToSpeakableText>
      >(
        CHAT_COMPLETIONS_API_URL,
        {
          model,
          messages,
          functions: [
            {
              name: 'question_to_speakable_text',
              type: 'object',
              description:
                'Your task is to convert provided question to a spoken-like text suitable for speech synthesis. Replace all KaTeX syntax and symbols with their corresponding plain text descriptions. For example, instead of writing "$u = 10\\\\frac{m}{s}$", express it as "u equals ten meters per second". Similarly, replace mathematical symbols like "$\\times$" with "times" or "$\\div$" with "divided by". The goal is to make the text easily understandable when spoken aloud by a virtual avatar.',
              parameters: {
                type: 'object',
                properties: {
                  questionSpeakableText: {
                    type: 'string',
                    description:
                      'Question from system message converted to speakable text. Note that this field is very important and should never be of type undefined, null or empty string.',
                  },
                  question: {
                    type: 'string',
                    description: 'Original question text.',
                  },
                  additionalComment: {
                    type: 'string',
                    description:
                      'Describe here if there is something challenging or difficult for you in this task. If you are not available to provide questionSpeakableText describe the reason in details. Also describe the status of this task.',
                  },
                },
                required: [
                  'questionSpeakableText',
                  'question',
                  'additionalComment',
                ],
              },
            },
          ],
          function_call: { name: 'question_to_speakable_text' },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${API_KEY}`,
          },
        },
      )

      const message = data.choices[0].message

      const parsedGptResponse =
        safeJsonParse<IGptResponseQuestionToSpeakableText>(
          message.function_call.arguments as unknown as string,
        )

      // do not remove! debug console message is used to debug ai model response on dev and prod env
      console.debug('function_call.arguments :>> ', parsedGptResponse)

      return parsedGptResponse
    } catch (err) {
      console.error(
        `questionToSpeakableTextGptRequest error with model ${model}: ` + err,
      )
      // If we have tried all models and still have an error, throw it
      if (model === models[models.length - 1]) {
        throw err
      }
    }
  }
}

export default questionToSpeakableTextGptRequest
